import { connect } from 'react-redux'
import ServiceProducts from '../../components/services/edit/ServiceProducts'
import { actionCreators, updateProducts } from '../../state/actions/services/index'
import { IStoreState, IProviderProductObject } from '../../types'
import { fetchProductsByOrganizationId } from '../../state/actions/provider-products'
import { getServicesProducts } from '../../state/reducers/provider-products/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const serviceId = ownProps.match ? ownProps.match.params.id : state.service.metadata.edit.serviceId
  const allProducts = Object.values(state.providerProduct.items)
  const serviceProducts = getServicesProducts(state, serviceId)
  const serviceProductIds = serviceProducts ? serviceProducts.map(p => p.id) : []
  const providerProducts = allProducts.filter(product => !serviceProductIds.includes(product.id))
  return {
    formRef: ownProps.formRef,
    onStepSuccessfullyCompleted: ownProps.onStepSuccessfullyCompleted,
    organizationId: state.organizations.currentOrgId || '',
    serviceId,
    serviceProducts,
    providerProducts
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchProductsByOrganizationId: (organizationId: string) => {
      const dto = {
        organizationId,
        skip: 0,
        take: 9999, // get all existing products
        active: true
      }
      dispatch(fetchProductsByOrganizationId(dto))
    },
    onSelectProduct: (product: IProviderProductObject, serviceId: string) => {
      return dispatch(actionCreators.selectProviderProduct(product, serviceId))
    },
    onRemoveProduct: (productId: string, serviceId: string) => {
      return dispatch(actionCreators.removeProviderProduct(productId, serviceId))
    },
    updateProducts: (serviceId: string, productIds: string[]) => {
      return dispatch(updateProducts(serviceId, productIds))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceProducts)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceProducts.ts